import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import Logo from "../../Images/mainlogo.png";

const HOVER_OPEN_DELAY = 80; // ms
const HOVER_CLOSE_DELAY = 300; // ms

const dropdowns = [
  {
    navTo: "/job",
    navToSub: ["/jobSub", "/jobSub", "/jobSub"],
    label: "Jobs",
    items: ["Jobs by Category", "Qualification", "Location"],
  },
  {
    navTo: "/resources",
    navToSub: [
      "/resourceGuid",
      "/resourceBlog",
      "/tesimonials",
      "/event",
    ],
    label: "Resources",
    items: [
      "Career Guides",
      "Blog",
      "Testimonials",
      "Events",
    ],
  },
  {
    navTo: "/placement",
    navToSub: "/placement",
    label: "Placement",
    items: ["Job Support", "Pan & World Wide", "Success Stories"],
  },
  {
    navTo: "/training",
    navToSub: ["/individualTraining", "/corporateTraining"],
    label: "Training",
    items: ["Individual Training", "Corporate Training"],
  },
  
  
  {
    navTo: "/partners",
    navToSub: ["/collegePartner", "/ngoPartner", "/corporatePartner"],
    label: "Partners",
    items: ["Colleges", "NGOs", "Corporates"],
  },
];

export default function CareerHeader() {
  const [isNavActive, setIsNavActive] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const openTimers = useRef({});
  const closeTimers = useRef({});

  const clearTimer = (ref, index) => {
    if (ref.current[index]) {
      clearTimeout(ref.current[index]);
      delete ref.current[index];
    }
  };

  const onTriggerEnter = (index) => {
    if (window.innerWidth <= 900) return;
    clearTimer(closeTimers, index);
    clearTimer(openTimers, index);
    openTimers.current[index] = setTimeout(() => {
      setActiveDropdown(index);
    }, HOVER_OPEN_DELAY);
  };

  const onTriggerLeave = (index) => {
    if (window.innerWidth <= 900) return;
    clearTimer(openTimers, index);
    clearTimer(closeTimers, index);
    closeTimers.current[index] = setTimeout(() => {
      setActiveDropdown((cur) => (cur === index ? null : cur));
    }, HOVER_CLOSE_DELAY);
  };

  const onMenuEnter = (index) => {
    if (window.innerWidth <= 900) return;
    clearTimer(closeTimers, index);
  };

  const onMenuLeave = (index) => {
    if (window.innerWidth <= 900) return;
    clearTimer(closeTimers, index);
    closeTimers.current[index] = setTimeout(() => {
      setActiveDropdown((cur) => (cur === index ? null : cur));
    }, HOVER_CLOSE_DELAY);
  };

  const onTriggerClick = (index, e) => {
    if (window.innerWidth > 900) return;
    e.preventDefault();
    setActiveDropdown((cur) => (cur === index ? null : index));
  };

  useEffect(() => {
    return () => {
      Object.values(openTimers.current).forEach((id) => clearTimeout(id));
      Object.values(closeTimers.current).forEach((id) => clearTimeout(id));
    };
  }, []);

  return (
    <header className="header">
      <div className="container">
        {/* Logo */}
        <div className="logo">
          <a href="/">
            <img src={Logo} alt="logo" />
          </a>
        </div>

        {/* Navigation */}
        <nav className={`nav ${isNavActive ? "active" : ""}`}>
          <ul className="nav-links">
            <li>
              <a href="/">Home</a>
            </li>

            <li>
              <a href="/about">About Us</a>
            </li>
            <li>
              <a href="/courses">
                Courses
              </a>
            </li>
             <li>
              <a href="/internship">Internships</a>
            </li>


            {dropdowns.map((dd, index) => {
              const isOpen = activeDropdown === index;
              return (
                <li
                  key={dd.label}
                  className={`dropdown ${isOpen ? "open" : ""}`}
                  onMouseEnter={() => onTriggerEnter(index)}
                  onMouseLeave={() => onTriggerLeave(index)}
                >
                  <a
                    href={dd.navTo}
                    aria-expanded={isOpen}
                    aria-haspopup="true"
                    onClick={(e) => onTriggerClick(index, e)}
                  >
                    {dd.label}
                  </a>

                  <ul
                    className="dropdown-menu"
                    role="menu"
                    onMouseEnter={() => onMenuEnter(index)}
                    onMouseLeave={() => onMenuLeave(index)}
                  >
                    {dd.items.map((item, subIndex) => {
                      let subLink = Array.isArray(dd.navToSub)
                        ? dd.navToSub[subIndex] || dd.navTo
                        : dd.navToSub || dd.navTo;

                      return (
                        <li key={item} role="menuitem">
                          <a href={subLink}>{item}</a>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })}
          </ul>

          {/* Call to Action */}
          <a href="/contact" className="cta">
            Join Now
          </a>
        </nav>

        {/* Mobile Menu Icon */}
        <div
          className="menu-toggle"
          onClick={() => setIsNavActive(!isNavActive)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
}
